import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Plus } from 'react-feather';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import InfoTooltip from 'components/shared/InfoTooltip';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import AddCriteriaModal from './AddCriteriaModal/AddCriteriaModal';

const AddCriteria = ({
  description,
  currentUserId,
  handleUpdate,
  selectedCriteria,
  canUseCustomFeedbackCriteria,
}) => {
  const [modalVisible, setModalVisisble] = useState(false);

  const toggleModal = () => {
    setModalVisisble(prev => !prev);
  };

  const criteriaDescription = description || t('feedback_criteria.description');

  return (
    <div>
      {!selectedCriteria && (
        <div className="d-f">
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="as-b">
            {t('feedback_criteria.feedback_criteria')}
            <InfoTooltip
              className="pl-4 mt-4 tooltip-fixedWidth c-gray-light"
              tooltip={t('feedback_criteria.description')}
            />
          </Text>
        </div>
      )}
      <button
        className="FeedbackCriteria-addCriteria d-f"
        onClick={toggleModal}
        type="button"
      >
        <Plus size={20} className=" mr-4" />
        <span className="ml-4 h-td-u fz-16">
          {t('feedback_criteria.add_criteria')}
        </span>
        {!selectedCriteria && (
          <span
            className="ml-4"
            data-toggle="tooltip"
            title={criteriaDescription}
            data-placement="top"
          />
        )}
      </button>
      {modalVisible && (
        <RenderInBody>
          <ModalContainer className="ModalTakeover-background Modal-background">
            <AddCriteriaModal
              toggleModal={toggleModal}
              handleUpdate={handleUpdate}
              selectedCriteria={selectedCriteria}
              canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
              currentUserId={currentUserId}
            />
          </ModalContainer>
        </RenderInBody>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  currentUserId: state.editor.currentUserId,
});

export default connect(mapStateToProps)(AddCriteria);
